import { TaskTypeId } from "@sp-crm/core";
import {
    byActivityTypeName,
    useActivityTypeOptionsState,
} from "components/tasks/activity-type-options";
import { Select } from "components/ui/select";
import React, { useMemo } from "react";
import {
    allTaskTypesSentinel,
    FilterableTaskTypes,
    unsetTaskTypeSentinel,
} from "store/slices/tasks-dashboard";

interface TaskTypeSelectProps {
    value: FilterableTaskTypes;
    onChange: (value: FilterableTaskTypes) => void;
    allowAllTaskTypes?: boolean;
    allowUnsetTaskType?: boolean;
    unsetLabel?: string;
}

export const TaskTypeSelect: React.FC<TaskTypeSelectProps> = props => {
    const { value, onChange, allowAllTaskTypes, unsetLabel, allowUnsetTaskType } = props;

    const { options, isLoading } = useActivityTypeOptionsState();

    const taskTypesOptions = useMemo(() => {
        return options
            .filter(option => !option.isArchived || option.id === (value as TaskTypeId))
            .sort(byActivityTypeName)
            .map(option => (
                <option key={option.id} value={option.id}>
                    {option.name || "(unnamed)"}
                </option>
            ));
    }, [options, value]);

    return isLoading ? (
        <Select label="Type" disabled value="loading">
            <option value="loading">Loading...</option>
        </Select>
    ) : (
        <Select
            label="Type"
            value={value}
            onChange={e => onChange(e.target.value as FilterableTaskTypes)}>
            {allowAllTaskTypes ? (
                <option value={allTaskTypesSentinel}>All Task Types</option>
            ) : null}
            {taskTypesOptions}
            {allowUnsetTaskType ? (
                <option value={unsetTaskTypeSentinel}>
                    {unsetLabel ?? "(Tasks without type set)"}
                </option>
            ) : null}
        </Select>
    );
};
